import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dea8706"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "icons icons-top"
}
const _hoisted_2 = { class: "icons icons-bot" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hazard-type-select" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "area-select"
}
const _hoisted_5 = ["onClick"]

import { ref, computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { find, get, flatten } from 'lodash'
import LeftLauncherIcon from '@/components/top/LeftLauncherIcon.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { useGpvStore } from '@/stores/gpvStore'
import { useGlobalStore } from '@/stores/globalStore'
import { LayoutInfoIconEvent, LayoutInfoIcon } from '@/models/initData/LayoutInfo'
import $ from 'jquery'


export default /*#__PURE__*/_defineComponent({
  emits: ['renderModeChange', 'event', 'selectArea', 'togglePanels'],
  setup(__props, { emit }) {

const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const gpvStore = useGpvStore()
const activeTopIcon = ref<string>('')
const activeBottomIcon = ref<string>('icon_rain_10')
const isActivePanels = ref(false)


onMounted(() => {
  if (globalStore.top.showPopup) {
    activeTopIcon.value = 'icon_popup'
  }

  // 初期状態の設定
  const defaultLayers = flatten([initDataStore.initData.layoutInfo.top.graphical.defaultLayer])

  if (globalStore.topIsGraphical) {
    if (defaultLayers.includes('view_definition') && !globalStore.isSP) {
      isActivePanels.value = true

      emit('togglePanels', isActivePanels.value)
    }

    defaultLayers.forEach(layer => {
      if (layer === 'view_definition') {
        return
      }

      activeTopIcon.value = layer
      emit('renderModeChange', layer)
    })
  }
})

const topIcons = computed(() => {
  const info = initDataStore.leftLauncherInfo(globalStore.top.viewType)
  let viewDefinitionIconIndex = -1

  if (!info) {
    return []
  }

  // SPのときに地図パネル表示アイコンを非表示
  if (globalStore.isSP) {
    viewDefinitionIconIndex = info.top.findIndex(icon => {
      return icon.event[0].function === 'view_definition'
    })
  }

  const spIcons = [...info.top]
  spIcons.splice(viewDefinitionIconIndex, 1)

  return viewDefinitionIconIndex === -1 ? info.top : spIcons
})

const bottomIcons = computed(() => {
  const info = initDataStore.leftLauncherInfo(globalStore.top.viewType)

  if (!info) {
    return []
  }
  return info.bottom
})

const areaList = computed(() => {
  const info = initDataStore.leftLauncherInfo(globalStore.top.viewType)
  const list = get(find(get(info, 'bottom'), { icon: 'icon_area' }), 'event.0.args', [])

  return list
})

const spShow = computed(() => {
  return globalStore.showLeftMenu ? 'show' : ''
})

const isActiveTop = (icon: LayoutInfoIcon) => {
  if (icon.event && icon.event[0].function === 'view_definition') {
    return isActivePanels.value
  }

  if (icon.icon === 'icon_popup') {
    return globalStore.top.showPopup
  }

  return activeTopIcon.value === icon.icon
}

const onClickTop = (icon: LayoutInfoIcon) => {
  if (icon.event && icon.event[0].function === 'view_popup') {
    globalStore.top.showPopup = !globalStore.top.showPopup
    return
  }

  // 局パネル
  if (icon.event && icon.event[0].function === 'view_definition') {
    isActivePanels.value = !isActivePanels.value

    emit('togglePanels', isActivePanels.value)

    return
  }

  if (activeTopIcon.value === 'launcher_quake' && !globalStore.isSP) {
    const top_view_selector = document.querySelector('.top-view-selector') as HTMLElement
    top_view_selector.style.display = 'flex'
  }

  if (activeTopIcon.value === icon.icon) {
    $('.icons-bot').show()
    activeTopIcon.value = ''
  } else {
    activeTopIcon.value = icon.icon
  }

  $('.icons-bot').show()
  emit('renderModeChange', activeTopIcon.value)
}

const onClickBottom = (icon: LayoutInfoIcon) => {
  const event = find(icon.event, { type: 'click' })
  activeBottomIcon.value = icon.icon

  // エリアアイコンだけ挙動が違う
  if (icon.icon !== 'icon_area') {
    emit('event', event)
  }
}

const onSelectArea = (area: LayoutInfoIconEvent) => {
  activeBottomIcon.value = ''
  emit('selectArea', area)
}

const route = useRoute()

watch(
  () => route.params.viewType,
  () => {
    activeBottomIcon.value = ''
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(spShow), "left-launcher"])
  }, [
    (_unref(gpvStore).success)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topIcons), (icon, index) => {
            return (_openBlock(), _createBlock(LeftLauncherIcon, {
              key: index,
              icon: icon,
              active: isActiveTop(icon),
              onClick: ($event: any) => (onClickTop(icon))
            }, null, 8, ["icon", "active", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bottomIcons), (icon, index) => {
        return (_openBlock(), _createBlock(LeftLauncherIcon, {
          key: index,
          icon: icon,
          onClick: ($event: any) => (onClickBottom(icon)),
          active: activeBottomIcon.value == icon.icon
        }, null, 8, ["icon", "onClick", "active"]))
      }), 128))
    ]),
    _hoisted_3,
    (activeBottomIcon.value === 'icon_area')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(areaList), (area, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "area-item",
              key: index,
              onClick: ($event: any) => (onSelectArea(area))
            }, _toDisplayString(area.title), 9, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})